import Axios from 'axios';
import BasePage from 'routes/BasePage';
import { BASE_URL } from 'common/config/baseUrl';
import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

const FullGuideTourRoutes = React.lazy(
  (): any => import('modules/FullGuideTour/replica/ReplicaRoutes')
);

export const APIUrl = BASE_URL;

Axios.defaults.baseURL = APIUrl;

function App() {
  return (
    <div className="App">
      {/* <TFInstallPrompt /> */}
      <Routes>
        {/* Standalone, outside MainLayout — the guide's replica demo pages */}
        <Route
          path="/full-guide-demo/*"
          element={
            <Suspense fallback={null}>
              <FullGuideTourRoutes />
            </Suspense>
          }
        />
        <Route path="/*" element={<BasePage />} />
      </Routes>
    </div>
  );
}
export default App;
